import * as amplitude from "@amplitude/analytics-browser";
import { memo, useEffect, useState } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { AMPLITUDE_API_KEY, AMPLITUDE_SERVER_URL } from "~/constants/index";
import { enableForEnv, Stages } from "~/lib/utils";
import AmplitudeSessionReplay, {
  enableAmplitudeSessionReplay,
} from "./AmplitudeSessionReplay";

const AmplitudeProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: user } = useGetCurrentUser();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!user?.email || !user?.role || isInitialized) return;

    if (enableForEnv([Stages.PRODUCTION, Stages.STAGING, Stages.DEV])) {
      amplitude.init(AMPLITUDE_API_KEY, {
        serverUrl: AMPLITUDE_SERVER_URL,
      });
      amplitude.identify(
        new amplitude.Identify().set("email", user.email).set("role", user.role)
      );
      amplitude.setUserId(user.email);
      setIsInitialized(true);
    }
  }, [user?.email, isInitialized]);

  useEffect(() => {
    if (!isInitialized || !user?.role) return;

    if (enableForEnv([Stages.PRODUCTION, Stages.STAGING, Stages.DEV])) {
      amplitude.identify(new amplitude.Identify().set("role", user.role));
    }
  }, [isInitialized, user?.role]);

  return (
    <>
      {children}
      {enableAmplitudeSessionReplay() && <AmplitudeSessionReplay />}
    </>
  );
};

export default memo(AmplitudeProvider);
